export const DATE_FORMAT = 'dd.MM.yyyy';
export const TIME_FORMAT = 'HH:mm';
export const KEY_DATE_FORMAT = 'DD.MM.YYYY';
export const KEY_TIME_FORMAT = 'HH:mm';
export const ISO_DATE_FORMAT = 'YYYY-MM-DD';
export const ISO_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const KEY_ENTER = 'Enter';
export const DATE_RANGE_SEPARATOR = '-';
export const DATE_PLACEHOLDER = '__.__.____';
export const DATE_TIME_PLACEHOLDER = '__.__.____ __:__';
export const DATE_RANGE_PLACEHOLDER = `__.__.____${DATE_RANGE_SEPARATOR}__.__.____`;
export const CALENDAR_CLASSNAME = 'adnz';
export const CALENDAR_PORTAL_ID = 'react-datepicker-portal';
export const DATE_PICKER_REF = 'datePickerRef';
export const DEFAULT_TIME_INTERVALS = 15;
export const DATE_PICKER_INPUT_MIN_WIDTH = 180;
export const DATE_PICKER_RANGE_INPUT_MIN_WIDTH = 220;
export const DEFAULT_DATE_PICKER_TRANSLATIONS = {
    time: 'Time',
};
export const DEFAULT_DATE_PICKER_RANGE_TRANSLATIONS = {
    period: 'Period',
};
